/**
 * TpControlTooltip Component
 *
 * Styled tooltip for timeline control buttons
 */

import { styled, Tooltip } from '@mui/material'

export const TpControlTooltip = styled(({ placement = 'top', offsetBottom = 0, slotProps, ...props }) => (
  <Tooltip
    enterDelay={1000}
    placement={placement} // this needs to be inserted before slotProps popper mods
    slotProps={{
      popper: {
        sx: {
          '& .MuiTooltip-tooltip': {
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: 1,
            fontStyle: 'italic',
    
            '& .MuiTypography-root': {
              fontSize: '0.75rem',
              fontStyle: 'italic',
              color: 'text.secondary',
            }
          },
          ...slotProps?.popper?.sx,
        },
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, offsetBottom], // Minimal gap from button
            },
          },
        ],
        ...slotProps?.popper,
      },
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    fontSize: '0.6875rem',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),
  },
}))
